export default function Share() {
  return <div>본인 인증하고 응모하기</div>;
}
